// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"d1492e29","453":"c27ecbf1","902":"05e936cd"}[chunkId] + ".chunk.js";
};